// Local Host Setup

// import axios from "axios";
// export const http = axios.create({ baseURL: "http://localhost:5009/" });
// export const apiUrl = "http://localhost:5009/uzorci/list/";
// export const apiUrlsve = "http://localhost:5009/uzorci/listsve/";
// export const apiUrlRez = "http://localhost:5009/rezultati/list/";
// export const apiUrlRezsve = "http://localhost:5009/rezultati/listsve/";
// export const apiUrloRez = "http://localhost:5009/rezultati/olist/";
// export const apiUrloRezsve = "http://localhost:5009/rezultati/olistsve/";
// export const apiUrlObrada = "http://localhost:5009/rezultati/nalazi/table/";
// export const apiUrlKont = "http://localhost:5009/kontrole/list";
// export const apiUrlPatient = "http://localhost:5009/pacijenti/detalji/";
// export const apiUrlNal = "http://localhost:5009/nalazi/list";
// export const apiUrlNalPre = "http://localhost:5009/nalazi/pregled";
// export const apiUrlOutbox = "http://localhost:5009/nalazi/outbox";
// export const apiUrlRac = "http://localhost:5009/uzorci/racuni/";
// export const barcode = "http://localhost:5009/images/barcodes/";
// export const server = "http://localhost:5009/";
// export const serverSocket = "http://localhost:5009/";

// Server Setup

import axios from "axios";
export const http = axios.create({ baseURL: "https://muminovic.atom-lis.com/" });
export const apiUrl = "https://muminovic.atom-lis.com/uzorci/list/";
export const apiUrlsve = "https://muminovic.atom-lis.com/uzorci/listsve/";
export const apiUrlRez = "https://muminovic.atom-lis.com/rezultati/list/";
export const apiUrlRezsve = "https://muminovic.atom-lis.com/rezultati/listsve/";
export const apiUrloRez = "https://muminovic.atom-lis.com/rezultati/olist/";
export const apiUrloRezsve = "https://muminovic.atom-lis.com/rezultati/olistsve/";
export const apiUrlObrada = "https://muminovic.atom-lis.com/rezultati/nalazi/table/";
export const apiUrlKont = "https://muminovic.atom-lis.com/kontrole/list";
export const apiUrlPatient = "https://muminovic.atom-lis.com/pacijenti/detalji/";
export const apiUrlNal = "https://muminovic.atom-lis.com/nalazi/list";
export const apiUrlNalPre = "https://muminovic.atom-lis.com/nalazi/pregled";
export const apiUrlOutbox = "https://muminovic.atom-lis.com/nalazi/outbox";
export const apiUrlRac = "https://muminovic.atom-lis.com/uzorci/racuni/";
export const barcode = "https://muminovic.atom-lis.com/images/barcodes/";
export const server = "https://muminovic.atom-lis.com/";
export const serverSocket = "https://muminovic.atom-lis.com/";


//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 93